export default function NotFoundPage() {
  return (
    <div>
      <section style={{
        minHeight: '100vh',
        background: 'linear-gradient(160deg, #065e32 0%, #007935 60%, #039160 100%)',
        display: 'flex', alignItems: 'center', justifyContent: 'center'
      }}>
        <h1 style={{ color: 'white', fontFamily: 'serif', fontSize: '4rem' }}>
          404 - Page Not Found
        </h1>
      </section>
    </div>
  )
}
